import { useMutation, useQueryClient } from "@tanstack/react-query";
import ordersClient, { Order } from "../../../api/order";

const useUpdateOrderCommentMutation = (orderId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (comment: string) =>
      ordersClient.updateOrderComment(orderId, comment),
    onSuccess: (updatedOrder: Order) => {
      queryClient.setQueryData(["order", orderId], updatedOrder);
      queryClient.invalidateQueries({ queryKey: ["orders"] });
    },
  });
};

export default useUpdateOrderCommentMutation;
